import React from 'react';
import './CheckBox.scss';

interface Props {
  id: string;
  name: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  checked?: boolean;
  label?: React.ReactNode;
  isDisabled?: boolean;
  className?: string;
}

const CheckBox: React.FC<Props> = ({ id, name, onChange, checked, label, isDisabled, className }) => {
  return (
    <div className={`checkbox ${isDisabled ? 'checkbox--disabled' : ''} ${className}`}>
      <label className="checkbox__label" htmlFor={id}>
        <input className="checkbox__input" checked={checked} id={id} name={name} onChange={onChange} type="checkbox" disabled={isDisabled} />
        <span className="checkbox__checkmark" />
        <div>{label}</div>
      </label>
    </div>
  );
};

export default CheckBox;
